import Textarea from "../../form_components/Textarea";
import { isJsonRules, validateInput } from "../../utilities/functions/validations";
import BaseNodeModel from "../BaseNodeModel";

export default class TaskOrchestrationNodeModel extends BaseNodeModel {
    /**
     * Input node model
     * @module TaskOrchestrationNodeModel
     * @param {string} nodeName Node display name
     * @param {number} x Node x coordinate on canvas
     * @param {number} y Node y coordinate on canvas
     * @param {Object} props Pre-defined node properties; if non-null, apply values to node properties
     * @param {string} id If non-null, use this ID as the node ID
     */
    constructor(nodeName = "UNTITLED_NODE", x = 0, y = 0, props = null, id = null) {
        super(nodeName, x, y, null, id);
        this.props.nodeTypeName = "Task Orchestration Node";
        this.props.colorClass = "yellow";
        this.props.iconClass = "refresh-cw";
        this.DEFAULT_COLOR_CLASS = "yellow";
        this.props.config = {
            type: "FORM",
            endTask: true,
            formVersion: -1,
            context: ""
        }
        this.applyProps(props);
    }

    setConfig(key, value) {
        super.setConfig(key, value);
        // Set formVersion as NULL whenever the formName is updated
        if (key === "formName") {
            super.setConfig("formVersion", -1)
        }
        // Refresh property panel when changing what type the node is using
        document.dispatchEvent(new CustomEvent("ev-property-refresh"));
    }

    getTypeOptions() {
        return [{
            name: "Form",
            value: "FORM"
        }];
    }

    getConfigViews() {
        const stepType = super.getConfig("type") || "FORM";
        this.props.configView = [];
        this.props.configView.push({ type: "hr" });
        switch (stepType) {
            case "FORM":
                this.props.configView.push(
                    { type: "FormListDropDown", label: "Form Name", key: "formName", optionName: "Form Name", tooltip: "A reference to the form artifact" },
                    { type: "FormVersionsDropDown", label: "Form Version", key: "formVersion", optionName: "Form Version", tooltip: "Version of the form" },
                    { type: "Switch", label: "Sensitive", key: "sensitive", checked: false },
                    { type: "Input", label: "Initial Duration", key: "initialDuration", tooltip: "How many seconds does this task last" },
                    { type: "Input", label: "Maximum Extensions", key: "maximumExtensions", tooltip: "How many times can this be extended" },
                    { type: "Input", label: "Extension Increment", key: "extensionIncrement", tooltip: "How many seconds is the time extended when requested" },
                    { type: "Input", label: "No Activity Timeout", key: "taskReservationDuration", tooltip: "How many seconds to wait for the task to be picked up" },
                    { type: "Input", label: "Task Reservation Limit", key: "taskCompletionLimit", tooltip: "How many seconds can the task take to completion from creation" },
                    <Textarea
                        valKey="context"
                        label="Context"
                        value={this.props.config.context}
                        isPropertyPanel
                        onChange={(value) => {
                            this.setConfig("context", value);
                            window.apm.updateParentNode(
                                this,
                                this.props.parentComponentID,
                                'context',
                                value,
                                this.type,
                                ''
                            );
                        }}
                        rows={5}
                        valRules={{_: (value) => validateInput(value, [isJsonRules])}}
                        placeholder="Enter JSON"
                        tooltip="JSON of attributes, values to be displayed in the header of the task form"
                      />
                );
                break;
            default:
                break;
        }

        return [
            ...this.getConfigViewNameField(),
            ...[
                { type: "Switch", label: "End Task", key: "endTask", checked: true, tooltip: "Change to FALSE if you want to keep the same agent for more steps later in the flow" },
                {
                    type: "Dropdown",
                    key: "type",
                    label: "Type",
                    optionName: "Type",
                    readOnly: true,
                    options: this.getTypeOptions(),
                    sel: this.getTypeOptions().findIndex((option) => option.value === stepType),
                },
            ],
            ...this.props.configView,
        ];
    }
}
